import { Button, ButtonVariant } from '@egw/components'
import { WEALTH_ROUTES } from '@egw/constants'
import { useTranslation } from '@egw/i18n'
import { EnrollmentMultiLayout } from '@egw/layouts'
import { CheckCircleIcon } from '@heroicons/react/24/outline'
import { type FC } from 'react'
import { useNavigate } from 'react-router'
import { PageHeader } from '../../../components'
import { ALL_ENROLLMENT_ROUTES } from '../../../constants'

export const AccountTransferSuccessPage: FC = () => {
  const { t } = useTranslation('features-enrollment')
  const navigate = useNavigate()

  const fundMoreHandler = (): void => {
    void navigate(`${WEALTH_ROUTES.ENROLLMENT.path}/${ALL_ENROLLMENT_ROUTES.MULTI.ROUTES.FUNDING.path}`)
  }

  const continueHandler = (): void => {
    void navigate(`${WEALTH_ROUTES.ENROLLMENT.path}/${ALL_ENROLLMENT_ROUTES.MULTI.ROUTES.CREATE_PASSKEY.path}`)
  }

  return (
    <EnrollmentMultiLayout title={t('multi.account_transfer_success.page_title')}>
      <CheckCircleIcon className="h-[4rem] w-[4rem] stroke-textSuccess stroke-[.5px] mb-2" />
      <PageHeader className="text-text-header-success" title={t('multi.account_transfer_success.title')} />
      <p className="text-text-body typo-primary-base my-md">{t('multi.account_transfer_success.description_1')}</p>
      <p className="text-text-body typo-primary-base mb-xl">{t('multi.account_transfer_success.description_2')}</p>
      <div className="flex flex-grow sm:hidden" />
      <div className="flex flex-col sm:flex-row gap-md w-full">
        <Button
          data-testid="fund-more-assets-button"
          variant={ButtonVariant.Secondary}
          className="w-full sm:w-fit"
          onClick={fundMoreHandler}
        >
          {t('multi.account_transfer_success.fund_more_assets')}
        </Button>
        <Button
          data-testid="continue-to-set-passkey-button"
          variant={ButtonVariant.Primary}
          className="w-full sm:w-fit"
          onClick={continueHandler}
        >
          {t('multi.account_transfer_success.continue_to_set_passkey')}
        </Button>
      </div>
    </EnrollmentMultiLayout>
  )
}
